import { render } from "./EvidenceDetail.vue?vue&type=template&id=75f866bb&scoped=true&ts=true"
import script from "./EvidenceDetail.vue?vue&type=script&lang=ts"
export * from "./EvidenceDetail.vue?vue&type=script&lang=ts"

import "./EvidenceDetail.vue?vue&type=style&index=0&id=75f866bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f866bb"]])

export default __exports__